
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.131 22.54l-6.537-6.537 6.536-6.538a2.452 2.452 0 000-3.465l-9.997 9.998L20.131 26a2.447 2.447 0 000-3.46z","fill":"#C1C8D6","fill-rule":"evenodd"}})])
          )
        }
      }
    